import { Box, Stack } from '@mui/material';
import ArticleCardSkeleton from '../ArticleCard/ArticleCardSkeleton';
import { v4 as uuidv4 } from 'uuid';
import { useSnapCarousel } from 'react-snap-carousel';

interface ArticleCarouselSkeletonProps {
  readonly limit: number;
  readonly carouselListStyle?: object;
}

export default function ArticleCarouselSkeleton({
  limit,
  carouselListStyle = {},
}: ArticleCarouselSkeletonProps) {
  const { scrollRef, snapPointIndexes } = useSnapCarousel();

  const components = [...Array(limit)].map((_, index) => {
    const uuid = uuidv4();
    return (
      <Box
        key={'carousel-skeleton-' + uuid}
        component='li'
        sx={{
          flexShrink: 0,
          maxWidth: '204px',
          width: '100%',
          ...(snapPointIndexes.has(index) && {
            scrollSnapAlign: 'start',
          }),
        }}
      >
        <ArticleCardSkeleton variant={'highlight'} />
      </Box>
    );
  });

  return (
    <Stack
      direction='row'
      component='ul'
      ref={scrollRef}
      useFlexGap
      sx={{
        gap: 2,
        paddingY: 0,
        listStyleType: 'none',
        overflow: 'auto',
        scrollSnapType: 'x mandatory',
        scrollbarWidth: 'none',
        '::-webkit-scrollbar': { display: 'none' },
        ...carouselListStyle,
      }}
    >
      {components}
    </Stack>
  );
}
